/*
 * LIOR x ABConvert - PT1 price-test display hooks
 * Theme: duplicate 188891758837 (unpublished until G2). Remove after PT1 ends.
 *
 * When ABConvert returns a test price for a tee variant, every custom price display
 * it can't reach on its own is re-rendered from that price:
 *   Shrine quantity tiles + PDP / sticky / ATC prices, Shrine bundle block,
 *   Roo Crew / Deal Days offer (roo-crew-offer.js), Rebuy widgets, product cards,
 *   hidden variant <select>.
 * Compare-at prices follow ABConvert's per-arm compare-at (Oct 10: Test's compare-at is raised so
 * both arms show the same % off): struck prices, % badges, tile and bundle struck totals, Roo tiers
 * and the Rebuy cart drawer use the arm's compare-at.
 *
 * Safety: does nothing when ABConvert has no price for the variant, when the visitor
 * is in control (test price == page price), or when the price currency isn't the page
 * currency. A write only happens when the element doesn't already show the target
 * amount, so it can't ping-pong with the theme or with ABConvert's own updates; a
 * run-rate breaker stops it if anything still loops.
 */
(function () {
  'use strict';
  if (window.__liorAbcHooks) return;

  var CFG = window.LIOR_ABC_CFG || {};
  var PRODUCTS = CFG.products || {}; // handle -> [productId, originalCents]
  var DEBUG = /[?&]abc_debug=1/.test(window.location.search);
  var H = (window.__liorAbcHooks = { version: 'pt1-2026-10-10', runs: 0, writes: 0, active: false, stopped: false });

  var ABC = null;
  var testById = {}; // variant id -> test cents, only where it differs from the page price
  var origById = {}; // variant id -> page price in cents (before any patch)
  var compareById = {}; // variant id -> compare-at cents
  var testCmpById = {}; // variant id -> this arm's compare-at cents, only where ABConvert's differs from the page's
  var asked = {}; // variant ids already looked up
  var productCents = {}; // product id -> { cents, cmp } | null
  var parsed = typeof WeakMap === 'function' ? new WeakMap() : null;
  var observer = null;
  var scheduled = false;
  var runTimes = [];

  function log() {
    if (DEBUG && window.console) console.log.apply(console, ['[abc-hooks]'].concat([].slice.call(arguments)));
  }
  function release() {
    document.documentElement.classList.remove('abc-hold');
  }

  /* ---------- money ---------- */
  function pageCurrency() {
    return (window.Shopify && Shopify.currency && Shopify.currency.active) || CFG.currency || '';
  }
  function okCurrency(p) {
    var c = pageCurrency();
    return !p.currency || !c || p.currency === c;
  }
  function toCents(amount) {
    return Math.round(Number(amount) * 100);
  }
  function money(cents) {
    var f = CFG.moneyFormat || '${{amount}}';
    if (typeof window.formatMoney === 'function') {
      try { return window.formatMoney(cents, f); } catch (e) { /* fall through */ }
    }
    return '$' + (Math.round(cents) / 100).toFixed(2);
  }
  // first money amount shown in an element, in cents
  function shown(el) {
    if (!el) return null;
    var m = (el.textContent || '').match(/\d[\d,]*(?:\.\d{1,2})?/);
    if (!m) return null;
    var v = parseFloat(m[0].replace(/,/g, ''));
    return isNaN(v) ? null : Math.round(v * 100);
  }
  function near(a, b) {
    return a != null && b != null && Math.abs(a - b) <= 1;
  }
  // the number part only ("40.99"), so a symbol / currency code around it stays as rendered
  function amountText(cents, noDecimals) {
    var s = null;
    if (typeof window.formatMoney === 'function') {
      try { s = window.formatMoney(cents, noDecimals ? '{{amount_no_decimals}}' : '{{amount}}'); } catch (e) { s = null; }
    }
    if (!s) s = (Math.round(cents) / 100).toFixed(noDecimals ? 0 : 2).replace(/\B(?=(\d{3})+(?!\d))/g, ',');
    return s;
  }
  // replace the amount inside an element's text, keeping its markup (e.g. Rebuy's sr-only label),
  // its currency symbol / code and its decimals style ("$50" stays "$47", "$37.99 USD" -> "$40.99 USD")
  function setMoney(el, cents) {
    if (!el || near(shown(el), cents)) return false;
    var walker = document.createTreeWalker(el, NodeFilter.SHOW_TEXT, null);
    var n;
    var target = null;
    while ((n = walker.nextNode())) {
      if (/\d/.test(n.nodeValue)) { target = n; break; }
    }
    if (target) {
      target.nodeValue = target.nodeValue.replace(/\d[\d,]*(?:\.\d{1,2})?/, function (tok) {
        return amountText(cents, tok.indexOf('.') < 0 && Math.round(cents) % 100 === 0);
      });
    } else {
      el.textContent = money(cents);
    }
    H.writes++;
    return true;
  }

  /* ---------- ABConvert lookups ---------- */
  // ABConvert keys this shop's price dict (window.abconvertPriceCartTransformTestDict) by GID,
  // e.g. "gid://shopify/ProductVariant/123", so look up the GID first and the bare id second.
  function abcLookup(fn, kind, id) {
    var s = String(id);
    var keys = s.indexOf('gid://') === 0 ? [s] : ['gid://shopify/' + kind + '/' + s, s];
    for (var i = 0; i < keys.length; i++) {
      var p = fn.call(ABC, keys[i]);
      if (p && p.amount != null) return p;
    }
    return null;
  }
  // ABConvert's price object for a variant ({ amount, compareAtAmount, currency, ... }) or null
  function abcVariant(variantId) {
    if (!ABC || typeof ABC.getPriceByVariantId !== 'function') return null;
    try {
      var p = abcLookup(ABC.getPriceByVariantId, 'ProductVariant', variantId);
      if (p && okCurrency(p)) return p;
    } catch (e) { /* not in a test */ }
    return null;
  }
  function testCents(variantId) {
    var p = abcVariant(variantId);
    return p ? toCents(p.amount) : null;
  }
  // product id -> { cents, cmp } | null; cmp = this arm's compare-at (null when ABConvert has none)
  function productTest(pid) {
    pid = String(pid);
    if (pid in productCents) return productCents[pid];
    var r = null;
    try {
      var p = ABC && typeof ABC.getPriceByProductId === 'function' ? abcLookup(ABC.getPriceByProductId, 'Product', pid) : null;
      if (p && okCurrency(p)) r = { cents: toCents(p.amount), cmp: p.compareAtAmount != null ? toCents(p.compareAtAmount) : null };
    } catch (e) { /* not in a test */ }
    if (ABC) productCents[pid] = r; // never cache a miss from before ABConvert was ready
    return r;
  }
  function productTestCents(pid) {
    var r = productTest(pid);
    return r ? r.cents : null;
  }
  function productTestCmp(pid) {
    var r = productTest(pid);
    return r ? r.cmp : null;
  }
  // compare-at shown for a variant in this arm, in cents (0 = none)
  function cmpOf(id) {
    id = String(id);
    return testCmpById[id] != null ? testCmpById[id] : compareById[id] || 0;
  }
  // true when this visitor sees a PT1 price that differs from the live price
  function inTestArm() {
    for (var h in PRODUCTS) {
      if (!Object.prototype.hasOwnProperty.call(PRODUCTS, h)) continue;
      var c = productTestCents(PRODUCTS[h][0]);
      if (c != null && c !== PRODUCTS[h][1]) return true;
    }
    return Object.keys(testById).length > 0;
  }

  /* ---------- variant data on the page ---------- */
  // every <script type="application/json"> holding Shopify variants (or Roo variants)
  function variantSources() {
    var out = [];
    var scripts = document.querySelectorAll('script[type="application/json"]');
    for (var i = 0; i < scripts.length; i++) {
      var s = scripts[i];
      var t = s.textContent || '';
      if (!t || t.length > 3000000 || t.indexOf('"price"') < 0) continue;
      var cached = parsed && parsed.get(s);
      if (cached && cached.len === t.length) { out.push(cached); continue; }
      var j;
      try { j = JSON.parse(t); } catch (e) { continue; }
      var arr = Array.isArray(j) ? j : j && Array.isArray(j.variants) ? j.variants : null;
      if (!arr || !arr.length || !arr[0] || typeof arr[0] !== 'object' || !('id' in arr[0]) || !('price' in arr[0])) continue;
      var src = { el: s, json: j, arr: arr, len: t.length };
      if (parsed) parsed.set(s, src);
      out.push(src);
    }
    return out;
  }
  function collect(srcs) {
    srcs.forEach(function (src) {
      var patched = src.el.hasAttribute('data-abc-patched');
      src.arr.forEach(function (v) {
        var id = String(v.id);
        var p = typeof v.price === 'string' ? parseInt(v.price, 10) : v.price;
        if (!patched && typeof p === 'number' && !(id in origById)) origById[id] = p;
        var c = v.compare_at_price != null ? v.compare_at_price : v.compare;
        if (c != null && !(id in compareById)) compareById[id] = parseInt(c, 10) || 0;
      });
    });
    Object.keys(origById).forEach(function (id) {
      if (asked[id]) return;
      asked[id] = true;
      var p = abcVariant(id);
      var t = p ? toCents(p.amount) : null;
      if (t == null || !(t > 0) || t === origById[id]) return; // control, or no test price
      testById[id] = t;
      var c = p.compareAtAmount != null ? toCents(p.compareAtAmount) : null;
      if (c != null && c > 0 && c !== compareById[id]) testCmpById[id] = c;
    });
  }
  // patch the JSON the theme reads on every variant change, and the copies it already parsed
  function patchSources(srcs) {
    srcs.forEach(function (src) {
      var changed = false;
      src.arr.forEach(function (v) {
        var t = testById[String(v.id)];
        if (t != null && v.price !== t) { v.price = t; changed = true; }
        var tc = testCmpById[String(v.id)];
        if (tc != null && 'compare_at_price' in v && Number(v.compare_at_price) !== tc) { v.compare_at_price = tc; changed = true; }
        if (tc != null && 'compare' in v && Number(v.compare) !== tc) { v.compare = tc; changed = true; }
      });
      if (changed) {
        src.el.textContent = JSON.stringify(src.json);
        src.el.setAttribute('data-abc-patched', '1');
        src.len = src.el.textContent.length;
        H.writes++;
      }
    });
    var els = document.querySelectorAll('variant-selects, secondary-variant-select, quantity-breaks, product-info-upsell');
    for (var i = 0; i < els.length; i++) {
      var el = els[i];
      if (Array.isArray(el.variantData)) {
        el.variantData.forEach(function (v) {
          var t = testById[String(v.id)];
          if (t != null && v.price !== t) v.price = t;
          var tc = testCmpById[String(v.id)];
          if (tc != null && 'compare_at_price' in v && Number(v.compare_at_price) !== tc) v.compare_at_price = tc;
        });
      }
      var cv = el.currentVariant;
      if (cv && testById[String(cv.id)] != null) cv.price = testById[String(cv.id)];
      if (cv && testCmpById[String(cv.id)] != null && 'compare_at_price' in cv) cv.compare_at_price = testCmpById[String(cv.id)];
    }
  }

  /* ---------- product page: Shrine quantity tiles, PDP / sticky / ATC prices ---------- */
  function sectionIds() {
    var ids = {};
    var els = document.querySelectorAll('product-info[data-section], quantity-breaks[data-section], variant-selects[data-section]');
    for (var i = 0; i < els.length; i++) ids[els[i].dataset.section] = true;
    return Object.keys(ids);
  }
  function currentVariantId(section) {
    var vs = document.getElementById('variant-selects-' + section);
    if (vs && vs.currentVariant && vs.currentVariant.id) return String(vs.currentVariant.id);
    var form = document.getElementById('product-form-' + section);
    var input = form && form.querySelector('[name="id"]');
    if (input && input.value) return String(input.value);
    var m = window.location.search.match(/[?&]variant=(\d+)/);
    return m ? m[1] : null;
  }
  function tileVariantId(qb) {
    var items = qb.querySelectorAll('.quantity-break__selector-item[data-selected-id]');
    for (var i = 0; i < items.length; i++) if (testById[items[i].dataset.selectedId] != null) return items[i].dataset.selectedId;
    return null;
  }
  function tileCents(label, base) {
    var qty = parseInt(label.dataset.quantity, 10) || 1;
    var pct = parseFloat(label.dataset.percentageLeft);
    var fixed = parseFloat(label.dataset.fixedDiscount) || 0;
    if (isNaN(pct)) pct = 1;
    return base * qty * pct - fixed;
  }
  function tilesStale(qb, base) {
    if (String(qb.dataset.basePrice) !== String(base)) return true;
    var labels = qb.labels || [];
    for (var i = 0; i < labels.length; i++) {
      var priceEl = labels[i].querySelector('.quantity-break__price');
      if (priceEl && !near(shown(priceEl), Math.round(tileCents(labels[i], base)))) return true;
    }
    return false;
  }
  // Shrine strikes each tile at baseComparePrice x quantity; "price"-mode tiles compare with the unit price
  function wantTileCmp(label, base, baseCmp) {
    return label.dataset.compareMode === 'price' ? base : baseCmp;
  }
  function tileCmpStale(qb, base, baseCmp) {
    var labels = qb.labels || [];
    for (var i = 0; i < labels.length; i++) {
      var w = wantTileCmp(labels[i], base, baseCmp);
      if (w != null && String(labels[i].dataset.baseComparePrice) !== String(w)) return true;
    }
    return false;
  }
  function setTileCmp(qb, base, baseCmp) {
    var labels = qb.labels || [];
    for (var i = 0; i < labels.length; i++) {
      var w = wantTileCmp(labels[i], base, baseCmp);
      if (w != null) labels[i].dataset.baseComparePrice = String(w);
    }
  }
  function pdpStale(section, cents, cmp) {
    var blocks = document.querySelectorAll('.price-' + section);
    for (var i = 0; i < blocks.length; i++) {
      var sale = blocks[i].querySelector('.price__sale .price-item--sale');
      var reg = blocks[i].querySelector('.price__regular .price-item--regular');
      if ((sale && !near(shown(sale), cents)) || (reg && !near(shown(reg), cents))) return true;
      var s = cmp != null && cmp > cents ? blocks[i].querySelector('.price__sale s.price-item') : null;
      if (s && !near(shown(s), cmp)) return true;
    }
    var spans = document.querySelectorAll('.main-atc-price-span-' + section);
    for (var j = 0; j < spans.length; j++) if (!near(shown(spans[j]), cents)) return true;
    return false;
  }
  function renderSection(section) {
    var vid = currentVariantId(section);
    var t = vid != null ? testById[vid] : null;
    var qb = document.getElementById('quantity-breaks-' + section);

    if (qb && qb.labels && typeof qb.initOfferPrices === 'function' && typeof qb.updateInnerPrices === 'function') {
      var baseVid = t != null ? vid : tileVariantId(qb);
      var base = baseVid != null ? testById[baseVid] : null;
      var baseCmp = baseVid != null && testCmpById[baseVid] != null ? testCmpById[baseVid] : null;
      if (base != null && (tilesStale(qb, base) || tileCmpStale(qb, base, baseCmp))) {
        qb.dataset.basePrice = String(base);
        setTileCmp(qb, base, baseCmp);
        qb.initOfferPrices(); // also refreshes the PDP prices when the selected tile drives them
        qb.updateInnerPrices();
        H.writes++;
      }
      if (base != null && qb.updatePdpPrices && qb.offerPrices) {
        var offer = qb.offerPrices['offer_' + qb.selectedOffer];
        if (offer) {
          var tilePrice = typeof qb.applySubTo === 'function' ? qb.applySubTo(offer.price) : offer.price;
          if (pdpStale(section, Math.round(tilePrice), Math.round(offer.compare_price))) { qb.updateDisplayedPdpPrices(); H.writes++; }
        }
        return;
      }
    }
    if (t == null) return;
    renderUnitPrices(section, t, cmpOf(vid), testCmpById[vid] != null);
  }
  // unit price in the PDP + sticky price blocks and ATC buttons, written the way the Liquid
  // render shows it in control (same currency code, floored % badge, money saved without .00)
  function renderUnitPrices(section, t, cmp, armCmp) {
    var blocks = document.querySelectorAll('.price-' + section);
    for (var i = 0; i < blocks.length; i++) {
      var b = blocks[i];
      setMoney(b.querySelector('.price__regular .price-item--regular'), t);
      setMoney(b.querySelector('.price__sale .price-item--sale'), t);
      if (cmp > t) {
        if (armCmp) setMoney(b.querySelector('.price__sale s.price-item'), cmp);
        var pct = b.querySelector('.badge__percentage-saved');
        var want = String(Math.floor(((cmp - t) * 100) / cmp));
        if (pct && pct.textContent.trim() !== want) { pct.textContent = want; H.writes++; }
        setMoney(b.querySelector('.badge__money-saved'), cmp - t);
      }
    }
    var spans = document.querySelectorAll('.main-atc-price-span-' + section);
    for (var j = 0; j < spans.length; j++) setMoney(spans[j], t);
  }

  /* ---------- Shrine bundle block ---------- */
  function renderBundles() {
    var bundles = document.querySelectorAll('bundle-deals');
    for (var b = 0; b < bundles.length; b++) {
      var bd = bundles[b];
      if (!bd.selectedVariants || !bd.checkboxes) continue;
      var touched = false;
      var hasCmp = false;
      for (var i = 0; i < bd.checkboxes.length; i++) {
        var cb = bd.checkboxes[i];
        var sv = bd.selectedVariants[cb.dataset.idIndex];
        if (!sv) continue;
        var t = testById[String(sv.id)];
        if (t == null) continue;
        var idx = parseInt(cb.dataset.index, 10);
        var picker = bd.querySelector('.bundle-deals__variant-selects-js[data-index="' + idx + '"]');
        var pct = picker ? parseFloat(picker.dataset.percentageLeft) : 1;
        var fixed = picker ? parseFloat(picker.dataset.fixedDiscount) || 0 : 0;
        if (isNaN(pct)) pct = 1;
        var item = t * pct - fixed;
        if (Math.abs(parseFloat(sv.price) - item) > 0.5) {
          sv.price = item;
          cb.dataset.price = String(item);
          touched = true;
        }
        var priceEl = bd.prices && bd.prices[idx];
        if (priceEl && !near(shown(priceEl), Math.round(item))) {
          priceEl.innerHTML = (bd.currencySymbol || '$') + (item / 100).toFixed(2);
          touched = true;
        }
        var tc = testCmpById[String(sv.id)];
        if (tc != null) {
          hasCmp = true;
          if (Math.abs(parseFloat(sv.comparePrice) - tc) > 0.5) {
            sv.comparePrice = tc;
            cb.dataset.comparePrice = String(tc);
            touched = true;
          }
          var cmpEl = bd.comparePrices && bd.comparePrices[idx];
          if (cmpEl && !near(shown(cmpEl), tc)) {
            cmpEl.innerHTML = (bd.currencySymbol || '$') + (tc / 100).toFixed(2);
            touched = true;
          }
        }
      }
      // struck total = the selected items' compare-at summed, as the theme renders it
      if (hasCmp && bd.totalComparePrice) {
        var csum = 0;
        for (var kc in bd.selectedVariants) {
          var vc = bd.selectedVariants[kc];
          if (vc && vc.checked) csum += parseFloat(vc.comparePrice) || 0;
        }
        var ctxt = (bd.currencySymbol || '$') + (Math.round(csum) / 100).toFixed(2);
        if (!near(shown(bd.totalComparePrice), Math.round(csum)) && bd.totalComparePrice.textContent.trim() !== ctxt) {
          bd.totalComparePrice.innerHTML = ctxt;
          H.writes++;
        }
      }
      if (!bd.totalPrice) continue;
      var sum = 0;
      for (var k in bd.selectedVariants) {
        var v = bd.selectedVariants[k];
        if (v && v.checked) sum += parseFloat(v.price) || 0;
      }
      var total = sum * (isNaN(bd.percentageLeft) ? 1 : bd.percentageLeft) - (bd.fixedDiscount || 0);
      // rounded like the Liquid render (and checkout), not floored like the theme's own recompute
      if (touched || !near(shown(bd.totalPrice), Math.round(total))) {
        var txt = (bd.currencySymbol || '$') + (Math.round(total) / 100).toFixed(2);
        if (bd.totalPrice.textContent.trim() !== txt) {
          bd.totalPrice.innerHTML = txt;
          H.writes++;
        }
      }
    }
  }

  /* ---------- Roo Crew / Deal Days offer (assets/roo-crew-offer.js exposes rooReprice) ---------- */
  function renderRoo() {
    var roots = document.querySelectorAll('[data-roo-offer]');
    for (var i = 0; i < roots.length; i++) {
      if (typeof roots[i].rooReprice === 'function' && roots[i].rooReprice(testById, testCmpById)) H.writes++;
    }
  }

  /* ---------- Rebuy widgets and product cards ---------- */
  function handleOf(href) {
    var m = String(href || '').match(/\/products\/([^/?#]+)/);
    if (!m) return null;
    try { return decodeURIComponent(m[1]).toLowerCase(); } catch (e) { return m[1].toLowerCase(); }
  }
  // only swap the live price for the test price; leave anything else (e.g. a widget discount) alone
  function swapPrice(el, handle, preferVariant) {
    var cfg = PRODUCTS[handle];
    if (!el || !cfg) return;
    var t = null;
    if (preferVariant && /^\d+$/.test(preferVariant)) t = testById[preferVariant] != null ? testById[preferVariant] : testCents(preferVariant);
    if (t == null) t = productTestCents(cfg[0]);
    if (t == null || t === cfg[1]) return;
    var now = shown(el);
    if (near(now, cfg[1])) setMoney(el, t);
  }
  function renderRebuy() {
    var blocks = document.querySelectorAll('.rebuy-widget .rebuy-product-block, [data-rebuy-id] .rebuy-product-block');
    for (var i = 0; i < blocks.length; i++) {
      var block = blocks[i];
      var a = block.querySelector('a[href*="/products/"]');
      var handle = a && handleOf(a.getAttribute('href'));
      if (!handle || !PRODUCTS[handle]) continue;
      var sel = block.querySelector('select');
      var priceEl = block.querySelector('.rebuy-money.sale') || block.querySelector('.rebuy-product-price .rebuy-money:not(.compare-at)');
      swapPrice(priceEl, handle, sel && sel.value);
    }
  }
  // Rebuy Smart Cart: each tee line's struck "Original price" (per shirt) and the subtotal's struck total
  function renderRebuyCart() {
    var items = document.querySelectorAll('.rebuy-cart__flyout-item');
    if (!items.length) return;
    var delta = 0;
    var any = false;
    for (var i = 0; i < items.length; i++) {
      var it = items[i];
      var a = it.querySelector('a[href*="/products/"]');
      var handle = a && handleOf(a.getAttribute('href'));
      if (!handle || !PRODUCTS[handle]) continue;
      var tc = productTestCmp(PRODUCTS[handle][0]);
      var el = it.querySelector('.rebuy-cart__flyout-item-price .rebuy-money.compare-at');
      if (tc == null || !el) continue;
      var now = shown(el);
      if (now == null) continue;
      var orig = el.getAttribute('data-abc-orig-cmp');
      orig = orig ? parseInt(orig, 10) : null;
      if (!near(now, tc)) {
        orig = now; // Rebuy rendered the store's compare-at
        el.setAttribute('data-abc-orig-cmp', String(now));
        setMoney(el, tc);
      }
      if (orig == null) continue;
      var q = it.querySelector('.rebuy-cart__flyout-item-quantity-widget-label');
      var m = q ? q.textContent.match(/\d+/g) : null;
      var qty = m ? parseInt(m[m.length - 1], 10) || 1 : 1;
      delta += (tc - orig) * qty;
      any = true;
    }
    var sub = document.querySelector('.rebuy-cart__flyout-subtotal-compare-amount');
    if (!any || !sub) return;
    var nowS = shown(sub);
    if (nowS == null) return;
    var setS = sub.getAttribute('data-abc-set-cmp');
    var origS = sub.getAttribute('data-abc-orig-cmp');
    if (setS == null || origS == null || !near(nowS, parseInt(setS, 10))) {
      origS = String(nowS); // Rebuy (re)rendered its own total
      sub.setAttribute('data-abc-orig-cmp', origS);
    }
    var want = parseInt(origS, 10) + delta;
    sub.setAttribute('data-abc-set-cmp', String(want));
    if (!near(nowS, want)) setMoney(sub, want);
  }
  var SKIP = 'product-info, quantity-breaks, bundle-deals, [data-roo-offer], .rebuy-widget, #rebuy-cart, sticky-atc';
  var PDP_PARTS = 'product-info, quantity-breaks, variant-selects, bundle-deals, [data-roo-offer]'; // a product page column, not a card
  function renderCards() {
    var links = document.querySelectorAll('a[href*="/products/"]');
    var done = [];
    for (var i = 0; i < links.length; i++) {
      var handle = handleOf(links[i].getAttribute('href'));
      if (!handle || !PRODUCTS[handle]) continue;
      var card = links[i].closest('.card-wrapper, .product-card-wrapper, .card, .grid__item');
      if (!card || done.indexOf(card) >= 0 || card.closest(SKIP) || card.querySelector(PDP_PARTS)) continue;
      done.push(card);
      var els = card.querySelectorAll('.price .price__regular .price-item--regular, .price .price__sale .price-item--sale');
      for (var j = 0; j < els.length; j++) swapPrice(els[j], handle, null);
      // the card's "SAVE NN%" / "NN%" badges are computed in Liquid from the live price (floored);
      // recompute them from the test price so the claim matches the price shown
      var t = productTestCents(PRODUCTS[handle][0]);
      var cmpEl = card.querySelector('.price .price__sale s.price-item, .price s.price-item');
      var cmp = cmpEl ? shown(cmpEl) : null;
      if (t == null || t === PRODUCTS[handle][1] || !cmp || cmp <= t) continue;
      // only a one-shirt card (showing the unit test price) gets the arm's compare-at
      var unitEl = card.querySelector('.price .price__sale .price-item--sale, .price .price__regular .price-item--regular');
      var tcmp = productTestCmp(PRODUCTS[handle][0]);
      if (tcmp != null && tcmp > t && !near(cmp, tcmp) && near(shown(unitEl), t)) { setMoney(cmpEl, tcmp); cmp = tcmp; }
      var pct = Math.floor((cmp - t) * 100 / cmp);
      var badges = card.querySelectorAll('.badge, .badge *');
      for (var k = 0; k < badges.length; k++) {
        var b = badges[k];
        if (b.children.length || !/\d+%/.test(b.textContent)) continue;
        var nt = b.textContent.replace(/\d+%/, pct + '%');
        if (nt !== b.textContent) { b.textContent = nt; H.writes++; }
      }
    }
  }

  /* ---------- hidden (no-JS) variant <select> ---------- */
  function renderSelectOptions() {
    var opts = document.querySelectorAll('select[name="id"] option[value]');
    for (var i = 0; i < opts.length; i++) {
      var o = opts[i];
      var t = testById[o.value];
      var orig = origById[o.value];
      if (t == null || orig == null) continue;
      var from = money(orig);
      var to = money(t);
      if (o.textContent.indexOf(from) >= 0) { o.textContent = o.textContent.replace(from, to); H.writes++; }
    }
  }

  /* ---------- run ---------- */
  // price containers only (not whole sections), so timers/sliders elsewhere don't wake the hooks
  var WATCH = [
    '.price', '[id^="price-"]', '[id^="main-atc-price"]', '[id^="sticky-atc-separate-price"]', '[id^="sticky-atc-price"]',
    'quantity-breaks', 'bundle-deals', '[data-roo-offer]',
    '.rebuy-widget', '[data-rebuy-id]', '.card-wrapper', '.product-card-wrapper',
    '.rebuy-cart__flyout-item-price', '.rebuy-cart__flyout-subtotal'
  ].join(',');

  function tooBusy() {
    var now = Date.now();
    runTimes.push(now);
    while (runTimes.length && now - runTimes[0] > 10000) runTimes.shift();
    return runTimes.length > 60; // > 60 runs in 10 s = something is fighting us
  }
  function applyAll() {
    if (scheduled || !ABC || H.stopped) return;
    if (tooBusy()) {
      H.stopped = true;
      if (observer) observer.disconnect();
      if (window.console) console.warn('[abc-hooks] stopped: price elements keep changing (possible conflict)');
      return;
    }
    H.runs++;
    if (!H.firstRunMs && window.performance) H.firstRunMs = Math.round(performance.now()); // QA: time to first price render
    scheduled = true; // re-entry guard
    if (observer) observer.disconnect();
    try {
      var srcs = variantSources();
      collect(srcs);
      if (Object.keys(testById).length) {
        patchSources(srcs);
        window.__liorAbcPrices = testById;
        window.__liorAbcCompares = testCmpById;
        sectionIds().forEach(renderSection);
        renderBundles();
        renderRoo();
        renderSelectOptions();
        H.active = true;
      }
      renderRebuy();
      renderCards();
      renderRebuyCart();
    } catch (e) {
      if (window.console) console.warn('[abc-hooks]', e);
    } finally {
      scheduled = false;
      release();
      if (observer) {
        observer.takeRecords();
        observe();
      }
    }
    log('run', H.runs, 'writes', H.writes, testById);
  }
  function relevant(m) {
    var n = m.target && m.target.nodeType === 1 ? m.target : m.target && m.target.parentElement;
    if (n && n.closest && n.closest(WATCH)) return true;
    var added = m.addedNodes || [];
    for (var i = 0; i < added.length; i++) {
      var a = added[i];
      if (a.nodeType === 1 && a.matches && (a.matches(WATCH) || a.querySelector(WATCH))) return true;
    }
    return false;
  }
  // Mutation callbacks run as a microtask after the theme's write and before the next paint,
  // so re-applying here means a test-arm visitor never sees the live price come back.
  function onMutations(muts) {
    if (scheduled || H.stopped) return;
    for (var i = 0; i < muts.length; i++) {
      if (relevant(muts[i])) { applyAll(); return; }
    }
  }
  function observe() {
    if (observer && document.body && !H.stopped) observer.observe(document.body, { childList: true, subtree: true, characterData: true });
  }

  function start(api) {
    if (ABC || !api) return;
    ABC = api;
    observer = typeof MutationObserver === 'function' ? new MutationObserver(onMutations) : null;
    applyAll();
    if (!inTestArm()) {
      // control, not assigned, or no PT1 product priced for this visitor: stay idle
      if (observer) observer.disconnect();
      observer = null;
      log('idle: no PT1 test price for this visitor');
      return;
    }
    log('active');
  }

  // QA only (?abc_debug=1): run the hooks against a stub price API before the test is live
  if (DEBUG) {
    H.simulate = function (api) {
      ABC = null; testById = {}; testCmpById = {}; asked = {}; productCents = {}; H.stopped = false;
      start(api);
      return H;
    };
  }

  window.ABConvertQueue = window.ABConvertQueue || [];
  window.ABConvertQueue.push(function (api) { start(api); });
  setTimeout(release, 2500); // never keep prices hidden longer than this
})();
